import { all } from 'redux-saga/effects';
import addIndividualDocumentWatcher from './individual-doc-saga';

export default function* rootSaga(action) {
	yield all([addIndividualDocumentWatcher(action)]);
}
